import { EKanbanCardProperty, IGetState, TBoardId, TKanbanCardProperty } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { boardSetUserMeta } from './boardSetUserMeta';

export const boardUserMetaSetCardPreviewHiddenProperties = (
    boardId: TBoardId,
    cardPreviewHiddenProperties: TKanbanCardProperty[],
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(boardSetUserMeta(boardId, { cardPreviewHiddenProperties }));
    };
    return action;
}
